import { Module } from '../../../ts/Module';
import { UserAgentSupport } from '../../utilities/UserAgentSupport';
import { FocusCtrl } from './FocusCtrl';

interface IFocusAttributes extends ng.IAttributes {
  tbFocus: string;
}

/**
 * Give an element focus when it is first rendered.
 */
Module.instance().directive('tbFocus', ['$timeout',
  ($timeout: ng.ITimeoutService) => {
      return {
        restrict: 'A',
        link: (scope: ng.IScope, element: JQuery, attrs: IFocusAttributes, ctrl: FocusCtrl) => {
          // Suppress on touch devices, as a keyboard can be very obtrusive
          if(UserAgentSupport.isTouch()) return;
          // this check is necessary to check for a directive call with no given attribute value
          if(attrs.tbFocus === 'tb-focus') attrs.tbFocus = 'true';
          if(!ctrl.hasFocusElement()) ctrl.setFocusElement(element);
          scope.$watch(attrs.tbFocus, (value: boolean) => {
            if(value) {
              $timeout(() => ctrl.focus());
            }
          });
        },
        controller: FocusCtrl
      };
    }]
);
